<template>
  <div class="menu-item" :class="[hasDesc ? 'has-desc' : '', 'menu-item-' + from]">
    <div class="row" v-if="icon">
      <div class="col icon">
        <svg-icon
          :class="icon"
          :style="from === 'button' ? 'color:' + color : ''"
          :icon-class="from === 'button' ? icon : 'menu_' + icon"
        ></svg-icon>
      </div>
      <div class="col content" :class="icon">
        <div class="title">{{ title }}</div>
        <div class="desc">{{ desc }}</div>
      </div>
    </div>
    <template v-else>
      <div class="title">{{ title }}</div>
      <div class="desc">{{ desc }}</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "menu-item",
  props: {
    title: String,
    desc: String,
    icon: String,
    color: String,
    from: {
      type: String,
      default: ""
    }
  },
  computed: {
    hasDesc() {
      return !!this.desc
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-item {
  width: 100%;
  min-height: 40px;
  padding: 12px 24px 12px;
  box-sizing: border-box;
  cursor: pointer;
  .logout {
    color: #ff7373;
    .title {
      color: #ff7373;
    }
  }
  &:hover {
    background-color: #f5f7fa;
  }
  .title {
    font-size: 14px;
    color: #606266;
  }
  .desc {
    font-size: 10px;
    color: #c0c4cc;
  }
  .row {
    display: flex;
    .col {
    }
    .icon {
      flex: 1;
      margin-right: 4px;
    }
    .content {
      flex: 5;
      align-self: center;
    }
  }
  &.has-desc {
    .title {
      padding-bottom: 4px;
    }
  }
}
.menu-item-navbar {
  padding: 12px 12px 12px !important;
  &:hover {
    border-radius: 4px;
  }
}
</style>
